import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty } from '../firestore/SectionAssignmentOutput/schema'
import type { FirestoreSectionAssignmentOutput } from '../firestore/SectionAssignmentOutput/schema'

export class SectionAssignmentOutput extends ObservableModelWithDecorators<FirestoreSectionAssignmentOutput> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSectionAssignmentOutput>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
